import React from "react";
import {AvatarFallback, AvatarProps} from "./avatar";
import {Avatar as ChakraAvatar} from "@chakra-ui3/react";
import {getLogoSrcSrcset} from "../../utils/logodev";
import {pickPalette} from "./pickPalette";

const CompanyLogo = React.forwardRef<HTMLDivElement, {name: string; domain?: string} & AvatarProps>(
  function CompanyLogo(props, ref) {
    const {name, src, domain, srcSet, loading, icon, fallback, children, ...rest} = props;
    const {source, src: fallbackSrc} = getLogoSrcSrcset(domain);
    return (
      <ChakraAvatar.Root ref={ref} colorPalette={pickPalette(name)} {...rest}>
        <AvatarFallback name={name} icon={icon}>
          {fallback}
        </AvatarFallback>
        <picture>
          <source key={source.type} type={source.type} srcSet={source.srcSet} />
          <ChakraAvatar.Image bg="white" src={src || fallbackSrc} srcSet={srcSet} loading={loading} />
        </picture>
        {children}
      </ChakraAvatar.Root>
    );
  },
);

export default CompanyLogo;
